import React, { Component } from 'react'
import Highlighter from 'react-highlight-words'
import * as JsSearch from 'js-search'

import './style.scss'

import data from './data.json'

class Search extends Component {
  state = {
    index: data[this.props.site],
    search: [],
    searchResults: [],
    isLoading: true,
    isError: false,
    searchQuery: '',
    searching: false,
    searchOpen: true,
    categories: [
      'General',
      'Guidelines',
      'Content',
      'Components',
      'Patterns',
      'Layout',
      'Utilities',
    ],
  }

  componentDidMount() {
    this.rebuildIndex()
  }

  rebuildIndex = () => {
    const { index } = this.state
    const dataToSearch = new JsSearch.Search('slug')

    /**
     *  defines a indexing strategy for the data
     * more about it in here https://github.com/bvaughn/js-search#configuring-the-index-strategy
     */
    dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()

    /**
     * defines the sanitizer for the search
     * to prevent some of the words from being excluded
     *
     */
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    /**
     * defines the search index
     * read more in here https://github.com/bvaughn/js-search#configuring-the-search-index
     */
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex('slug')

    dataToSearch.addIndex('name') // sets the index attribute for the data
    dataToSearch.addIndex('description') // sets the index attribute for the data
    dataToSearch.addIndex('category') // sets the index attribute for the data

    dataToSearch.addDocuments(index) // adds the data to be searched
    this.setState({ search: dataToSearch, isLoading: false })
  }

  searchData = e => {
    const { search } = this.state
    const queryResult = search.search(e.target.value)
    this.setState({
      searchQuery: e.target.value,
      searchResults: queryResult,
      searching: true,
    })
  }

  handleSubmit = e => {
    e.preventDefault()
  }

  stopPropagation = e => {
    e.stopPropagation()
  }

  noSearch = e => {
    setTimeout(() => this.setState({ searching: false }), 200)
  }

  /* Turns on the search results */
  openSearch = e => {
    this.setState({ searching: true })
  }

  /* Toggles search box */
  startSearch = e => {
    this.setState(prevState => ({
      searchOpen: !prevState.searchOpen,
    }))
  }

  render() {
    const { index, searchResults, searchQuery } = this.state
    const queryResults = searchQuery === '' ? index : searchResults
    return (
      <div className="search">
        <div
          tabIndex="0"
          className={
            'search__icon ' +
            (this.state.searchOpen && 'open') +
            ' ' +
            (this.state.searching && 'searching')
          }
          role="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
          >
            <path
              fill={this.state.searching ? '#007856' : '#fff'}
              d="M10,1 C14.9705627,1 19,5.02943725 19,10 C19,12.124779 18.2636898,14.0775836 17.0323074,15.6171757 L22.7279221,21.3137085 C23.1184464,21.7042328 23.1184464,22.3373978 22.7279221,22.7279221 C22.3373978,23.1184464 21.7042328,23.1184464 21.3137085,22.7279221 L15.6171757,17.0323074 C14.0775836,18.2636898 12.124779,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 Z"
            />
          </svg>
          {this.state.searchOpen && (
            <form
              onSubmit={this.handleSubmit}
              autocomplete="off"
              className="search__form"
            >
              <input
                id="Search"
                value={searchQuery}
                onChange={this.searchData}
                onClick={this.stopPropagation}
                onBlur={this.noSearch}
                placeholder="Search Currency"
                className="search__input"
                autoFocus={this.state.searchOpen}
              />
            </form>
          )}
        </div>

        {this.state.searching && (
          <div className="search__results">
            {this.state.categories.map(cat => (
              <div>
                {queryResults.filter(e => e.category === cat).length > 0 && (
                  <div className="search__category">
                    <Highlighter
                      highlightClassName="search__highlight"
                      searchWords={[this.state.searchQuery]}
                      autoEscape={true}
                      textToHighlight={cat}
                    />
                  </div>
                )}
                {queryResults
                  .filter(e => e.category === cat)
                  .map(item => (
                    <div className="search__item-container">
                      <a
                        className="search__item"
                        href={
                          '/' +
                          this.props.site +
                          '/' +
                          (this.props.state
                            ? item.slug +
                              (this.props.state ? '/' + this.props.state : '/')
                            : item.slug + '/design')
                        }
                        key={`row_${item.slug}`}
                      >
                        <span className="search__name">
                          <Highlighter
                            highlightClassName="search__highlight"
                            searchWords={[this.state.searchQuery]}
                            autoEscape={true}
                            textToHighlight={item.name}
                          />
                        </span>
                      </a>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}
export default Search
